// Helpers de motion reutilizáveis pela transição "Iniciar etapa" — qualquer
// outro componente animado da Jornada pode reusar em vez de reimplementar.

// jsdom não implementa matchMedia; guard evita quebrar testes/SSR.
export function prefersReducedMotion() {
  return !!(
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  )
}

export function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
